(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('ScheduleValidator', ScheduleValidator);

    ScheduleValidator.$inject = ['$resource'];

    function ScheduleValidator($resource) {

        return {
            scheduleStartEndDateValidator: scheduleStartEndDateValidator
        }

        /***
         * startDate and End Date validator
         * @param startDate
         * @param endDate
         * @param serviceItemId
         * @param scheduleInfoId
         * @returns {*}
         */
        function scheduleStartEndDateValidator(startDate, endDate, serviceItemId, scheduleInfoId) {

            if (startDate && endDate && serviceItemId && scheduleInfoId) {
                var parameters = '?startDate=' + (startDate).toLocalISOString() + '&endDate=' + (new Date(endDate)).toLocalISOString() + '&serviceItemId=' + serviceItemId + '&scheduleInfoId=' + scheduleInfoId;
                return $resource('api/schedule-startend-date-validator' + parameters, {}, {
                    'get': {
                        method: 'GET', params: {}, isArray: false,
                        interceptor: {
                            response: function (response) {
                                // expose response
                                return response;
                            }
                        }
                    }
                });
            }
        }


        return service;
    }
})();
